
      const loadingPage = document.querySelector("#initial-loading-page")
      const sessionStorage = window.sessionStorage.getItem("initial-loading-page-shown")

      if (!sessionStorage) {
         loadingPage.style.display = "flex"
      }
   